import Embed from './embed'
import Shop from './shop'
import Catalog from './catalog'
import Product from './product'

import Checkout from './checkout'
import Cart from './cart'
import PaymentMethods from './payment-method'
import User from './user'

import Table from './table'

export default class Api {
  constructor({ config, transports }) {
    this._config = config;
    this._transports = transports;

    this.initEmbed();
    this.initShop();
    this.initCatalog();
    this.initTable();
    this.initUser();
    this.initCart();
    this.initProduct();
    this.initCheckout();
    this.initPaymentMethods();

    this._store = null;
  }

  init(locales) { 
    return new Promise((resolve, reject) => {
      let ret = {};
      this.user.view().then((user) => {
        ret.user = user;
        const locale = locales.find(l => {
          return l.toISO639() === user.lang;
        });
        
        this.embed.get({ 
          id: '5eccefa6e92aa456ed14d372', 
          locale: locale.toISO3166()
        }).then((embed) => {
          ret.embed = embed;

          this.shop.get({ 
            id: embed.shop, 
            locale: locale.toISO3166() 
          }).then((shop) => {
              ret.embed.shop = shop;
              ret.shop = shop;
              ret.services = [];
              
              this.table.get({ shopId: shop.id }).then((tables) => {
                ret.tables = tables;
                
                Object.keys(ret.shop.services).forEach(s => {
                  if(!embed.excludedServices.includes(s)) {
                    ret.services.push(s);
                  }
                });

                this.catalog.get({ 
                  id: shop.catalog,
                  locale: locale.toISO3166()
                }).then((catalog) => {
                  ret.shop.catalog = catalog;
                  ret.catalog = catalog;
                  
                  this.cart.view({
                    shop_id: shop.id,
                    embed_id: embed.id,
                    service: 'eatin',
                    catalog_id: catalog.id,
                    locale: locale.toISO3166()
                  }).then((cart) => {
                    ret.cart = cart;
                    resolve(ret);
                  }).catch(reject);
                }).catch(reject)
                
              })
            }).catch(reject);
        }).catch(reject);
      }).catch(reject);
    });
  }

  initCart() {
    this.cart = new Cart({
      config: this._config.find(el => el.fqn === "ifm.curry.cart"), 
      transports: this._transports
    });
  }

  initCatalog() {
    this.catalog = new Catalog({ 
      config: this._config.find(el => el.fqn === "ifm.curry.catalog"), 
      transports: this._transports
    });
  }

  initCheckout() {
    this.checkout = new Checkout({
      config: this._config.find(el => el.fqn === "ifm.curry.checkout"), 
      transports: this._transports
    });
  }

  initEmbed() { 
    this.embed = new Embed({
      config: this._config.find(el => el.fqn === "ifm.curry.embed"), 
      transports: this._transports
    });
  }

  initPaymentMethods() { 
    this.pm = new PaymentMethods({
      config: this._config.find(el => el.fqn === "ifm.curry.payment-method"), 
      transports: this._transports
    })
  }

  initProduct() { 
    this.product = new Product({ 
      config: this._config.find(el => el.fqn === "ifm.curry.product"), 
      transports: this._transports
    });
  }

  initShop() { 
    this.shop = new Shop({
      config: this._config.find(el => el.fqn === "ifm.curry.shop"), 
      transports: this._transports
    });
  }

  initTable() { 
    this.table = new Table({
      config: this._config.find(el => el.fqn === "ifm.curry.table"), 
      transports: this._transports
    });
  }

  initUser() { 
    this.user = new User({
      config: this._config.find(el => el.fqn === "ifm.curry.user"), 
      transports: this._transports
    });
  }
}